import React from 'react';
import PropTypes from 'prop-types';
import './LabelField.css';

const LabelField = props => (
  <div className="label-field" >
    <div>{props.label}</div>
    <div>{props.value}</div>
  </div>
);

LabelField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.node,
};

export default LabelField;



// WEBPACK FOOTER //
// ./src/components/LabelField/LabelField.jsx